import { createRoute } from '@tanstack/react-router';

import { AccessGuard } from 'src/guards/AccessGuard';
import { AuthGuard } from 'src/guards/AuthGuard';
import { NotFoundFeature } from 'src/pages/errors/NotFoundFeature';
import { NoveltiesDefaultPage } from 'src/pages/novelties/NoveltiesDefaultPage';
import { NoveltiesPage } from 'src/pages/novelties/NoveltiesPage';
import { RootRoute } from 'src/routes/__root';

export const NoveltiesRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/novelties',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <NoveltiesPage />
      </AccessGuard>
    </AuthGuard>
  ),
  notFoundComponent: () => (
    <NotFoundFeature
      route='/novelties'
      routeTitleKey='Go to the novelties page'
    />
  ),
});

export const NoveltiesDefaultRoute = createRoute({
  getParentRoute: () => NoveltiesRoute,
  path: '/',
  component: NoveltiesDefaultPage,
});
